var _path, _path2, _circle, _circle2, _circle3, _path3, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandAmbassador(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "outline",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88,296V472a24.02687,24.02687,0,0,0,24,24H400a24.02687,24.02687,0,0,0,24-24V296H408V472a8.00917,8.00917,0,0,1-8,8H112a8.00917,8.00917,0,0,1-8-8V296Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104,40a8.00917,8.00917,0,0,1,8-8H400a8.00917,8.00917,0,0,1,8,8V184h16V40a24.02687,24.02687,0,0,0-24-24H112A24.02687,24.02687,0,0,0,88,40V184h16Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 56,
    r: 8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 56,
    r: 8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 56,
    r: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.38818,266.15381l89.39551,13.75293a8.002,8.002,0,0,0,4.79395-.75147l22.45947-11.22949L190.41418,336H144v16H368V336H321.58582l12.37707-68.07422,22.45947,11.22949a7.985,7.985,0,0,0,4.79395.75147l89.396-13.75293A25.22381,25.22381,0,0,0,448,216.0293V208a7.99977,7.99977,0,0,0-8-8H424a7.99877,7.99877,0,0,0-5.65674,2.34326L404.686,216h-24.939L342.146,170.87842a8.0055,8.0055,0,0,0-3.33692-2.36914l-53.35376-20.00769A31.822,31.822,0,0,0,288,136V96a7.99943,7.99943,0,0,0-3.5625-6.65625L265.07861,76.438A26.42176,26.42176,0,0,0,224,98.42236V136a31.82094,31.82094,0,0,0,2.54474,12.50159l-53.35382,20.00769a8.0055,8.0055,0,0,0-3.33692,2.36914L132.25293,216H107.314L93.65674,202.34326A7.99877,7.99877,0,0,0,88,200H72a7.99977,7.99977,0,0,0-8,8v8.0293a25.22377,25.22377,0,0,0-2.61182,50.12451ZM427.314,216H432v8a7.99977,7.99977,0,0,0,8,8h6.77637a9.22383,9.22383,0,0,1,1.40283,18.34033l-25.9541,3.99286-5.54077-27.704ZM240,120h32v16a16,16,0,0,1-32,0Zm16,48a31.83,31.83,0,0,0,19.05591-6.30994l24.55493,9.20807L256,226.96924l-43.61084-56.07111,24.55493-9.20807A31.83,31.83,0,0,0,256,168Zm-5.57764-80a10.39285,10.39285,0,0,1,5.78125,1.75049L272,100.28174V104H240V98.42236A10.434,10.434,0,0,1,250.42236,88ZM136,232a8.00149,8.00149,0,0,0,6.146-2.87842l38.64453-46.374,15.90558-5.96454,52.98895,68.1286a8.0004,8.0004,0,0,0,12.62988,0l52.989-68.1286,15.90551,5.96454,38.64453,46.374A8.00149,8.00149,0,0,0,376,232h25.44153l4.95373,24.76849-45.095,6.93756-29.72265-14.86132a8.00022,8.00022,0,0,0-11.44873,5.72412L305.32324,336H206.67676l-14.80567-81.43115a8.00022,8.00022,0,0,0-11.44873-5.72412l-29.72265,14.86132-45.09491-6.93756L110.55847,232Zm-70.77637,0H72a7.99977,7.99977,0,0,0,8-8v-8h4.686l10.62963,10.62921L89.7749,254.33313l-25.95361-3.9928A9.22379,9.22379,0,0,1,65.22363,232Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 376,
    width: 40,
    height: 16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 376,
    width: 24,
    height: 16
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 416,
    width: 56,
    height: 16
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 416,
    width: 56,
    height: 16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandAmbassador);
export default __webpack_public_path__ + "static/media/brand-ambassador.efa19e00.svg";
export { ForwardRef as ReactComponent };